import {
  prefOnlyFlgSelector,
  prefOnlySelectJobCountSelector,
} from '@doda/common/src/redux/features/prefOnlyFlgSlice';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { useAppSelector } from '@doda/pc/src/redux/hooks';

/**
 * 地域のみで募集中ボタンの表示判定
 * @returns 地域のみで募集中ボタン表示フラグ
 */
export const usePrefOnlyButton = () => {
  const appQuery = useAppSelector(appQueryParamsSelector);
  const { nearArea } = appQuery;
  const prefOnlyFlg = useAppSelector(prefOnlyFlgSelector);
  const prefJobCount = useAppSelector(prefOnlySelectJobCountSelector);

  const isShowPrefOnlyButton = prefOnlyFlg && prefJobCount >= 1 && !nearArea;

  return {
    isShowPrefOnlyButton,
  };
};
